import React from 'react';
import { useSelector } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { SaleCouponDiscountType } from '../../../components/collectionBuilder/constants';
import { ViewSectionRow } from '../../../components/layouts/viewSectionRow';

import { ViewTable } from '../../../components/layouts/viewTable';
import { ICouponCode } from '../../../models/CouponCode';
import { RootState } from '../../../store';
import CurrencyHelper from '../../../helpers/currencyHelper';

const generateCouponDisplayName = (coupon: ICouponCode, currency?: string) => {
  let value = `${coupon.discountTypeValue}`;

  if (coupon.discountType === SaleCouponDiscountType.AsPercentage) {
    value += '%';
  } else if (coupon.discountType === SaleCouponDiscountType.AsFixedValue) {
    value = CurrencyHelper.formatCurrency(Number(coupon.discountTypeValue), currency);
  }

  return `${coupon.couponCode} (${value} off)`;
};

export const TicketCouponCodes = () => {
  const ticketing = useSelector((state: RootState) => state.ticketing);
  const relatedData = ticketing.relatedRecord?.data?.data;
  const currency = relatedData?.currency;

  if (relatedData?.couponCodes?.length > 0) {
    return (
      <div className="ticket-action-container">
        <ViewTable
          title={<Translate value="ticketing.edit.coupon-codes.header" />}
        >
          <ViewSectionRow
            title="ticketing.edit.coupon-codes.code-list.label"
            data={relatedData.couponCodes.map((coupon: ICouponCode) => (
              <div key={coupon.couponCode}>
                {generateCouponDisplayName(coupon, currency)}
              </div>
            ))}
          />
        </ViewTable>
      </div>
    );
  }

  return null;
};
